<template>
    <div class="vis--wrapper">
        <!-- <DatasetTitle :title="dataTitle"/> -->
        <!-- <Legend :content="content" /> -->
    </div>
</template>

<script>
        
    import Legend from './Legend.vue';
    import { mapState } from 'vuex';
    import DatasetTitle from '../components/DatasetTitle.vue'

    import { fetch as fetchPolyfill } from 'whatwg-fetch'

    import { 
        select as d3Select,
        selectAll as d3SelectAll,
        scaleLinear as d3ScaleLinear,
        json as d3Json,
        extent as d3Extent,
        nest as d3Nest,
        timeYear as d3TimeYear,
        ascending as d3Ascending,
        scaleSequential as d3ScaleSequential,
        interpolateCool as d3InterpolateCool,
        axisTop as d3AxisTop,
        format as d3Format,
    } from 'd3';

    import { setTimeout } from 'timers';

    export default {
        name: 'LineStacking',
        components: {
            Legend,
            DatasetTitle
        },
        data() {
            return {
                svg: null,
                svgWrapper: null,
                container: null,
                transitionDuration: 250,
                popupTimeout: 650,
                margin: {
                    left: 30,
                    right: 10,
                    top: 145,
                    bottom: 30,
                },
                width: null,
                height: null,
                radius: 250,
                xScale: null,
                xAxis: null,
                resizeId: null,
                visWidth: null,
                clientWidth: null,
                clientHeight: null,
                dataNesting: null,
                gradScale: null,
                dataCurrent: null,
                groupDefs: null,
                course: null,
                year: null,
                groupSpacing: 20,
                lineSpacing: 2,
                groupAxis: null,
                groupLines: null,
                classGroups: null,
                groupLabels: null, 
                groupHover: null,
                gOne: null,
                sublineYAxisDiv: null,
                datasetTitleText: null,
                mouseTimeout: null,
                scrollTimeout: null,
                posTop: 0
            }
        },
        props: ['statements', 'sublineYAxis', 'dataTitle', 'svgHeight', 'content', 'sidebarVisible', 'snippet', 'pos', 'timeout', 'highlight', 'snippetCurrent', 'paragraphActive', 'dataActive', 'dataset'],
        computed: {
            ...mapState(['sidebarToggled']),
        },
        watch: {
            sidebarVisible() {
                this.sidebarIsVisible();
            },
            sublineYAxis() {
                this.doneResizing()
            },
            dataTitle() {
                this.doneResizing()
            },
            snippetCurrent() {
                this.dispatchVisRendered(false);
                this.highlightRects();
            },
            dataset() {
                this.dispatchVisRendered(false);
                this.updateVis()
            },
            sidebarToggled() {
                this.clientWidth = d3Select('#app').node().getBoundingClientRect().width;

                if (this.clientWidth < 1000 && this.sidebarToggled) {
                    d3Select('.popup').classed('behind', true);
                } else {
                    d3Select('.popup').classed('behind', false);
                }

                this.resizing();
            }
        },
        methods: {
            dispatchTimeout(state) {
                this.$store.dispatch("SET_TIMEOUT", state);
            },
            dispatchScrolling(state) {
                this.$store.dispatch("SET_SCROLLING", state);
            },
            dispatchPopupPos(state) {
                this.$store.dispatch("SET_POPUP_POS", state);
            },
            getDimensions() {
                this.clientWidth = d3Select('#app').node().getBoundingClientRect().width;
                this.clientHeight = d3Select('#app').node().getBoundingClientRect().height;

                if (this.clientWidth > 1080) {
                    this.visWidth = d3Select('#app').node().getBoundingClientRect().width - d3Select('.sidebar-wrapper').node().getBoundingClientRect().width - 40;
                } else {
                    this.visWidth = d3Select('#app').node().getBoundingClientRect().width;
                }

            },
            dispatchVisRendered(state) {
                this.$store.dispatch("SET_VIS_RENDERED", state);
            },
            dispatchYearsExtend(state) {
                this.$store.dispatch("SET_YEARS_EXTEND", state);
            },
            dispatchSvgHeight(state) {
                this.$store.dispatch("SET_SVG_HEIGHT", state);
                this.svgWrapper.attr('height', state)
            },
            setSvgHeight() {
                const sel = d3SelectAll('.groupLabelsText')['_groups'][0];

                const lastId = sel.length - 1;
                // setTimeout(() => {
                    const pos = sel[lastId].getBoundingClientRect().top + 250;
                    this.dispatchSvgHeight(pos);
                    return pos;
                // }, 100);
            },
            resetHighlights() {
                d3SelectAll('rect.linePath').classed('inactive', false);
            },
            highlightRects() {
                this.dispatchVisRendered(false);

                if (this.highlight.length == 0) {
                    d3SelectAll('rect.linePath').classed('inactive', false);
                } else {
                    d3SelectAll('rect.linePath').classed('inactive', true);
    
                    this.highlight.forEach(id => {
                        d3Select(`rect#id-${id}`).classed('inactive', false);
                    })
                }
            
                
                this.setSvgHeight();


                this.dispatchVisRendered(true);
                
            },
            updateVis() {
                this.dispatchSvgHeight(1500);
                this.requestData(this.dataset);
            },
            fetchPositions() {
                this.course = null;
                this.year = null;
                let nodeCourse = d3Select(`rect#id-${this.snippet.pos[0]}`);

                if (nodeCourse.node() != null) {
                    this.course = nodeCourse.node().getBoundingClientRect();
                    this.year = this.xScale(this.snippet.pos[1]);

                    let distToTop = this.course.top - this.radius;
                    let distToLeft = this.year - this.radius - this.margin.left - 380;

                    this.dispatchPopupPos([distToLeft, distToTop]);
                }

            },
            init() {
                d3Select('vis--svg').remove();

                this.clientWidth = d3Select('#app').node().getBoundingClientRect().width;

                if (this.clientWidth < 500) {
                    this.margin = {
                        left: 15,
                        right: 20,
                        top: 120,
                        bottom: 30,
                    }
                } else if (this.clientWidth > 500) {
                    this.margin = {
                        left: 30,
                        right: 30,
                        top: 145,
                        bottom: 30,
                    }
                }

                this.height = this.clientHeight - this.margin.top - this.margin.bottom;
                this.width = this.clientWidth - this.margin.left - this.margin.right;

                this.container = d3Select('.vis--wrapper')

                this.svgWrapper = this.container.append('svg')
                    .attr('id', 'vis--svg')
                    .attr('width', this.clientWidth)
                    .attr('height', this.clientHeight)
                    .on('wheel', (d,i) => {
                        let time = new Date();
                        this.dispatchScrolling(time.getTime())
                    })
                    


                this.svg = this.svgWrapper
                    .append("g")
                    .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");

                this.xScale = d3ScaleLinear()
                    .domain([this.statements.startYear, + this.statements.endYear])
                    .rangeRound([0, this.width]);

                this.groupDefs = this.svg.append("g")
                    .attr("id", "groupDefs");

                this.groupAxis = this.svg.append("g")
                    .attr("id", "groupAxis");

                this.groupLines = this.svg.append("g")
                    .attr("id", "groupLines");

                this.gOne = this.groupDefs.append("defs")
                    .append("linearGradient")
                    .attr("id", "group-one")
                    .attr("x1", '0%')
                    .attr("y1", '0%')
                    .attr("x2", '100%')
                    .attr("y2", '0%');

                this.gOne.append("stop")
                    .attr("offset", 0)
                    .attr("stop-color", "#ffffff")
                    .attr("stop-opacity", 0);

                this.gOne.append("stop")
                    .attr("offset", 1)
                    .attr("stop-color", '#2EC33F')
                    .attr("stop-opacity", 1);

                this.sublineYAxisDiv = this.svg.append('g')
                    .attr('id', 'sublineYAxis')
                    .append('text')
                    .attr('class', 'subline-label')

                this.datasetTitleText = this.svg.append('g')
                    .attr('id', 'datasetTitleText')
                    .append('text')
                    .attr('class', 'dataset-title')

                this.groupLabels = this.svg.append("g")
                    .attr("id", "groupLabels");

                this.groupHover = this.svg.append("g")
                    .attr("id", "groupHover");

                this.xAxis = d3AxisTop(this.xScale)
                    // .tickFormat(d3Format("d"))
                    // .ticks(2)

                this.groupAxis.append("g")
                    .attr("class", "xAxis axis")
                    .attr("transform", "translate(-"+ 0 +"," + (-25) + ")")
                    .call(this.xAxis)

                this.requestData(this.dataset);
            },
            requestData(url) {
                fetchPolyfill(url)
                    .then(data => {
                        return data.json();
                    }).then(json => {
                        this.transformData(json);
                    })
                    .catch(err => { })
            },
            transformData(data) {

                let curGrad, min, max, gradColor;

                this.gradScale = d3ScaleLinear()
                    .range([0,1]);

                this.gradColorScale = d3ScaleSequential()
                    .domain([1, 60])
                    .interpolator(d3InterpolateCool);

                var currTermYear = 0;

                var totalMin = 2200;
                var totalMax = 1800;
                
                data.forEach((e,groupI) => {

                    e.values.forEach(d => {

                        min = +d.values[0].year+.02;

                        if (min < totalMin){ totalMin = min; }

                        max = +d.values[d.values.length-1].year;

                        if (max > totalMax){ totalMax = max; }

                        if (d.values.length > 2) {

                            curGrad = this.groupDefs.append("defs")
                                .append("linearGradient")
                                .attr("id", "g"+groupI+'-'+d.key)
                                .attr("x1", '0%')
                                .attr("y1", '0%')
                                .attr("x2", '100%')
                                .attr("y2", '0%');

                            this.gradScale.domain([min,max]);

                            d.values.forEach((g,j) => {

                                if (j === 1) {
                                    gradColor = 'red';
                                } else {
                                    gradColor = this.gradColorScale(g.year - min);
                                }

                                curGrad.append("stop")
                                    .attr("offset", this.gradScale(g.year))
                                    .attr("stop-color", gradColor)
                                    .attr("stop-opacity", 1);

                                curGrad.append("stop")
                                    .attr("offset", this.gradScale(g.year)+.001)
                                    .attr("stop-color", "#ccc")
                                    .attr("stop-opacity", .05);

                            })
                        }
                    })
                });

                /////// Axis Domain Transform
                const extend = [totalMin,totalMax];
                this.dispatchYearsExtend(extend);
                this.xScale.domain(extend);
                
                this.drawGroups(data);
            },
            groupLabelVis(data) {
                
                let groupLabeling = this.groupLabels.selectAll(".groupLabelsText")
                    .data(data, (d,i) => { return i; });

                groupLabeling.exit().remove();

                groupLabeling.transition()
                    .attr("transform", (d,i) => {
                        return "translate("+ (0) +"," + (d.groupPosition*this.lineSpacing+this.groupSpacing*i - 15) + ")"
                    })
                    .text(d => { return d.key });

                groupLabeling
                    .enter()
                    .append('text')
                    .attr('class', 'groupLabelsText')
                    .attr("transform", (d,i) => {
                        return "translate("+ (0) +"," + (d.groupPosition*this.lineSpacing+this.groupSpacing*i - 15) + ")"
                    })
                    .attr("dy", ".5em")
                    .attr("dx", ".5em")
                    .text(d => { return d.key });
            },
            drawGroups(data) {

                d3Select('.xAxis')
                    .transition()
                    .duration(this.transitionDuration)
                    .call(this.xAxis)               
                    .end()
                    .then(() => {
                        this.dispatchVisRendered(true);
                    })
                    .catch(err => {}) 

                d3Select('g.axis').selectAll('text').attr('id', function(d) { 
                    // return `id-${this.innerHTML}` 
                    return `id-${Math.round(d)}` 
                });

                this.groupLines.selectAll(".areaGroup").remove();
                this.groupHover.selectAll('.hover').remove();

                //////////// Optimal LineHeight Calculation
                //////////// Optimal LineHeight Calculation

                this.lineSpacing = 3;

                var totalVisHeight = (this.margin.top + this.margin.bottom) + (this.groupSpacing*(data.length-1)) + (data[data.length-1].groupPosition + data[data.length-1].groupSize) * this.lineSpacing;

                if (totalVisHeight < window.innerHeight) {
                    var givenHeight = Math.floor((window.innerHeight - totalVisHeight) / (data[data.length-1].groupPosition + data[data.length-1].groupSize));

                    if (givenHeight >= 2) {
                        this.lineSpacing = givenHeight;
                    }
                }

                //////////// Optimal LineHeight Calculation End
                //////////// Optimal LineHeight Calculation End

                this.classGroups = this.groupLines.selectAll(".areaGroup")
                    .data(data)
                    .enter()
                    .append("g")
                    .attr('class', 'areaGroup')
                    .attr('transform', (d,i) => { return 'translate(0,'+(d.groupPosition*this.lineSpacing+this.groupSpacing*i)+')'; })
                    .selectAll(".linePath")
                    .data(d => { return d.values; }, function(d) { return d.key; })
                    .enter()
                    .append('rect')
                    .attr('class', 'linePath')
                    .attr('id', d => { return `id-${d.key}`; })
                    .attr('x', d => { return this.xScale(d.values[0].year); })
                    .attr('y', d => { return d.yPos*this.lineSpacing; })
                    .attr('width', 0)
                    .attr('height', 1.25)
                    .attr("fill", function(d) {
                        if (d.values.length == 2) {
                            return  "url(#group-one)"
                        } else {
                            return "url(#g"+d.values[0].groupI+"-"+d.key+")" // d.values[0].groupI
                        }
                    })
                    .attr('stroke', 'rgba(0,0,0,0)')
                    .attr('stroke-width', this.lineSpacing+'px')
                    .on('mouseover', d => {
                        return this.mouseOver(d);
                    })
                    .transition()
                    .delay((d,i) => {
                        return i*10
                    })
                    .duration(500)
                    .attr('width', d => { 
                        const val = this.xScale(d.values[d.values.length-1].year)-this.xScale(d.values[0].year);
                        return val < 0 ? 0 : val; })
                    .end()
                    .then(() => {
                        this.dispatchVisRendered(true);
                    })
                    .catch(err => {});

                if (this.statements.areaGroup !== 'externalCourseId') {
                    this.groupLabelVis(data);  
                }

                this.highlightRects();
            },
            mouseOver(data) {

                this.groupHover.selectAll('.hover').remove();

                var dataVal = data.values;
                var currYPos = data.yPosTotal*this.lineSpacing+this.groupSpacing*dataVal[0].groupI;

                // -------- Point Highlight

                this.groupHover
                    .selectAll(".hoverPoints")
                    .data(dataVal)
                    .enter()
                    .append('circle')
                    .attr('class', 'hoverPoints hover')
                    .style("stroke", 'white')
                    .style("stroke-width", 2)
                    .attr('fill', 'black')
                    .attr('cx', d => { return this.xScale(+d.year) })
                    .attr('cy', currYPos+.5)
                    .attr('r', (d,i) => {
                        if (i == 0) {
                            return 0
                        } else {
                            return 2
                        }
                    });

                var titleData = dataVal.filter(d => { return d.title !== undefined });

                // -------- White background Shadow behind Text

                var whiteSpace = 5;
                var textWidth = 6;

                var textAnchor = 'start';

                if (this.xScale(titleData[0].year) > this.visWidth/2) {
                    textAnchor = 'end';
                }

                this.groupHover
                    .selectAll(".bgHoverRect")
                    .data(titleData)
                    .enter()
                    .append('rect')
                    .attr('class', 'hoverText bgHoverRect hover')
                    .attr("transform", (d,i) => {
                        d.textAnchor = textAnchor;
                        d.currYPos = currYPos;
                        if (textAnchor == 'start') {
                            if (i % 2 == 0) {
                                return "translate("+ this.xScale(+d.year) +"," + (currYPos - 15) + "), rotate(-10), skewX(-10)"
                            } else {
                                return "translate("+ this.xScale(+d.year) +"," + (currYPos + 5) + "), rotate(10), skewX(10)"
                            }
                        } else {
                            if (i % 2 == 0) {
                                return "translate("+ this.xScale(+d.year) +"," + (currYPos + 20) + "), rotate(-190), skewX(-10)"
                            } else {
                                return "translate("+ this.xScale(+d.year) +"," + currYPos + "), rotate(190), skewX(10)"
                            }
                        }
                    })
                    .attr('height', 15)
                    .attr('width', d => { return d.title.length * textWidth + whiteSpace*2})

                // -------- Text to Read

                this.groupHover
                    .selectAll(".fgHoverText")
                    .data(titleData)
                    .enter()
                    .append('text')
                    .attr('class', 'hoverText fgHoverText hover')
                    .style("font-size", '10px')
                    .style("text-anchor", textAnchor)
                    .attr("transform", (d,i) => {
                        if (textAnchor == 'start') {
                            if (i % 2 == 0) {
                                return "translate("+ this.xScale(+d.year) +"," + (currYPos - 5) + "), rotate(-10), skewX(-10)"
                            } else {
                                return "translate("+ this.xScale(+d.year) +"," + (currYPos + 15) + "), rotate(10), skewX(20)"
                            }
                        } else {
                            if (i % 2 == 0) {
                                return "translate("+ (this.xScale(+d.year)-5) +"," + (currYPos + 15) + "), rotate(-10), skewX(-10)"
                            } else {
                                return "translate("+ (this.xScale(+d.year)-5) +"," + (currYPos - 5) + "), rotate(10), skewX(20)"
                            }
                        }
                    })
                    .text(d => { return d.title});

                // -------- Title Points

                this.groupHover
                    .selectAll(".hoverTitlePoints")
                    .data(titleData)
                    .enter()
                    .append('circle')
                    .attr('class', 'hoverTitlePoints hoverPoints hover')
                    .style("stroke", 'black')
                    .style("stroke-width", 1)
                    .attr('fill', 'none')
                    .attr('cx', d => { return this.xScale(+d.year) })
                    .attr('cy', currYPos+.5)
                    .attr('r', 3);                
                
                this.mouseTimeInterval();

            },
            mouseTimeInterval() {

                if (this.mouseTimeout) {
                    clearTimeout(this.mouseTimeout);
                } else {
                    this.mouseTimeout = setTimeout(this.hoverTimeoutRemoval, 15000);
                }

            },
            hoverTimeoutRemoval() {

                this.mouseTimeout = null;

                this.groupHover
                    .selectAll(".hoverTitlePoints")
                    .transition()
                    .delay((d,i)=>{ return i * 200 })
                    .duration(200)
                    .attr('r', 0);

                this.groupHover
                    .selectAll(".hoverPoints")
                    .transition()
                    .delay((d,i)=>{ return i * 200 })
                    .duration(200)
                    .attr('r', 0);

                this.groupHover
                    .selectAll(".bgHoverRect")
                    .style('opacity', 1)
                    .transition()
                    .delay((d,i)=>{ return i * 200 })
                    .duration(200)
                    .attr("transform", (d,i) => {
                        if (d.textAnchor == 'start') {
                            if (i % 2 == 0) {
                                return "translate("+ this.xScale(+d.year) +"," + (d.currYPos - 15) + "), rotate(0), skewX(-10)"
                            } else {
                                return "translate("+ this.xScale(+d.year) +"," + (d.currYPos + 5) + "), rotate(0), skewX(10)"
                            }
                        } else {
                            if (i % 2 == 0) {
                                return "translate("+ this.xScale(+d.year) +"," + (d.currYPos + 20) + "), rotate(-180), skewX(-10)"
                            } else {
                                return "translate("+ this.xScale(+d.year) +"," + d.currYPos + "), rotate(180), skewX(10)"
                            }
                        }
                    })
                    .transition()
                    .duration(100)
                    .style('opacity', 0)
                    .remove();

                // -------- Text to Read

                this.groupHover
                    .selectAll(".fgHoverText")
                    .style('opacity', 1)
                    .transition()
                    .delay((d,i)=>{ return i * 200 })
                    .duration(200)
                    .attr("transform", (d,i) => {
                        if (d.textAnchor == 'start') {
                            if (i % 2 == 0) {
                                return "translate("+ this.xScale(+d.year) +"," + (d.currYPos - 5) + "), rotate(0), skewX(-10)"
                            } else {
                                return "translate("+ this.xScale(+d.year) +"," + (d.currYPos + 15) + "), rotate(0), skewX(20)"
                            }
                        } else {
                            if (i % 2 == 0) {
                                return "translate("+ (this.xScale(+d.year)-5) +"," + (d.currYPos + 15) + "), rotate(0), skewX(-10)"
                            } else {
                                return "translate("+ (this.xScale(+d.year)-5) +"," + (d.currYPos - 5) + "), rotate(0), skewX(20)"
                            }
                        }
                    })
                    .transition()
                    .duration(100)
                    .style('opacity', 0)
                    .remove()
                    .end()
                    .then(() => {
                        this.groupHover.selectAll('.hover')
                            .style('opacity', 1)
                            .transition()
                            .delay(400)
                            .duration(200)
                            .style('opacity', 0)
                            .remove();
                    });

            },
            sidebarIsVisible() {
                this.container.attr('class', `vis--wrapper ${this.sidebarVisible}`);
            },
            doneResizing() {
                this.getDimensions()

                let time = new Date();
                this.dispatchScrolling(time.getTime())

                const sel = d3SelectAll('.groupLabelsText')['_groups'][0];

                if (sel.length > 0) {
                    const lastId = sel.length - 1;
                    const height = sel[lastId].getBoundingClientRect().top + 150;
        
                    this.svgWrapper
                        .attr('width', this.visWidth)
                        .attr('height', height)
                }


                this.width = (this.visWidth) - this.margin.left - this.margin.right;

                this.xScale
                    .rangeRound([0, this.width]);

                this.xAxis = d3AxisTop(this.xScale).tickFormat(d3Format("d")).ticks(6);

                d3Select('.xAxis')
                    .transition()
                    .duration(this.transitionDuration)
                    .call(this.xAxis)   

                this.groupLines.selectAll(".areaGroup").selectAll(".linePath")
                    .transition()
                    .duration(this.transitionDuration)
                    .attr('x', d => { return this.xScale(d.values[0].year); })
                    .attr('width', d => { return this.xScale(d.values[d.values.length-1].year)-this.xScale(d.values[0].year); });

                
                if (this.clientWidth < 500) {
                    this.datasetTitleText
                        .text(this.dataTitle)
                        .attr('transform', d => { return `translate(7, -83)` })
                        
                    this.sublineYAxisDiv
                        .text(this.sublineYAxis)
                        .attr('transform', d => { return `translate(7, -65)` })

                } else if (this.clientWidth > 500) {
                    this.datasetTitleText
                        .text(this.dataTitle)
                        .attr('transform', d => { return `translate(7, -96)` })
                        
                    this.sublineYAxisDiv
                        .text(this.sublineYAxis)
                        .attr('transform', d => { return `translate(7, -75)` })
                }

                    

            },
            resizing() {
                clearTimeout(this.resizeId);
                this.resizeId = setTimeout(this.doneResizing, 500);
            }
        },
        componenDidUpdate() {
        },
        mounted() {
            this.init();
            this.resizing();
            this.updateVis();
            this.sidebarIsVisible();
            

            window.addEventListener('resize', () => {
                if (this.clientWidth < 1000 && this.sidebarToggled) {
                    d3Select('.popup').classed('behind', true);
                } else {
                    d3Select('.popup').classed('behind', false);
                }
                this.resizing();
            });
        },
        created() {
        }
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .subline-label {
        font-size: 13px;
        letter-spacing: .25px;
        opacity: .4;
    }

    .vis {
        &--wrapper {
            -ms-overflow-style: none;
            width: 100%;
            overflow-x: hidden;
            overflow-y: scroll;
            height: 100%;
            transition: all $time-m ease-in-out;

            @media screen and (max-width: 768px) {
                position: absolute;
            }

            // &.left {
            //     transform: translateX($sidebar-width);
            //     transition: all $time-m ease-in-out;
            // }

            // &.right {
            //     transform: translateX(-$sidebar-width);
            //     transition: all $time-m ease-in-out;
            // }
            
        }
    }

    /*---------CSS For Axis-----------*/

    .axis .domain{
    stroke: none;
    }

    rect {
        opacity: 1;
        transition: opacity $time-m ease-in-out;
        &.inactive {
            opacity: .15;
            transition: opacity $time-m ease-in-out;
        }
    }


    /*---------CSS For Hover Text-----------*/

    .hoverText{
    pointer-events: none;
    font-family: 'IBM Plex Mono', monospace;
    font-style: italic;
    }
    .bgHoverRect{
    fill: white;
    }
    .fgHoverText{
    fill: black;
    stroke: none;
    font-size: .8em;
    }

    g.tick > text {
        font-family: 'IBM Plex Mono';
        transform: translateY(-2px);
    }

    /*---------Label Text-----------*/

    .groupLabelsText{
    font-size: $font-size-s;
    text-transform: inherit;
    font-family: 'IBM Plex Sans';
    letter-spacing: .25px;
    // opacity: .4;
    /*transform: skew(-10deg);*/
    }

    .dataset-title {
        opacity: 1;
        fill: black;
        font-size: 20px;
        font-weight: bold;
        // display: none;
    }
    
</style>
